<div class="progress-button actions-wrapper" [ngClass]="state">
  <button
    [disabled]="isDisabled || state !== 'initial'"
    [type]="buttonType"
    [class.button-loader]="state === 'loading'"
    (click)="onPress.emit()"
    data-qa="profile.profile-change_button"
    class="button button--wide"
  >
    <span
      *ngIf="state === 'initial'"
      [innerHTML]="buttonText | translate"
      class="button__wrapper"
    ></span>
  </button>

  <ng-container [ngSwitch]="state">
    <svg *ngSwitchCase="'loading'" class="i-spinner" viewBox="0 0 50 50" width="50" height="50">
      <!-- circle -->
      <circle class="i-spinner__path" cx="25" cy="25" r="15" fill="none" stroke-width="3"></circle>
    </svg>
    <svg *ngSwitchCase="'error'" viewBox="0 0 70 70" width="70" height="70">
      <!-- cross -->
      <path d="m35,35l-9.3,-9.3" stroke-width="3"></path>
      <path d="m35,35l9.3,9.3" stroke-width="3"></path>
      <path d="m35,35l-9.3,9.3" stroke-width="3"></path>
      <path d="m35,35l9.3,-9.3" stroke-width="3"></path>
    </svg>
    <svg *ngSwitchCase="'success'" viewBox="0 0 70 70" width="70" height="70">
      <!-- checkmark -->
      <path d="m31.5,46.5l15.3,-23.2" stroke-width="3"></path>
      <path d="m31.5,46.5l-8.5,-7.1" stroke-width="3"></path>
    </svg>
  </ng-container>
</div>
